module.exports = __webpack_public_path__ + "8f3ae70471d2dcede52fb49b606272b2.svg";